module.exports = __webpack_public_path__ + "img/purple-bannerbg.e1d7a4ca.png";